import actions from './actions'

export default function PartTransfersReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_PARTTRANSFER:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.FETCH_PARTTRANSFER2_REC:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_PARTTRANSFER:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_PARTTRANSFER:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_PARTTRANSFER:
      return {
        ...state,
        editing: { partTransferID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_PARTTRANSFER_RECIEVED ||
      actions.UPDATE_PARTTRANSFER_RECIEVED ||
      actions.DELETE_PARTTRANSFER_RECIEVED:
      return {
        ...state,
        editing: { partTransferID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
